import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { keyListener } from "../../../lib/events/keyListener";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { isExternalLink } from "../../../lib/utils";
import { Spinner } from "../../Spinner";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Link.styles";
/**
 * Элемент ссылки из HTML.
 */

export var Link = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Link, _React$Component);

  function Link() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      focusedByTab: false
    };
    _this.theme = void 0;

    _this.renderMain = function (props) {
      var _cx;

      var disabled = props.disabled,
          href = props.href,
          icon = props.icon,
          use = props.use,
          loading = props.loading,
          _button = props._button,
          _buttonOpened = props._buttonOpened,
          relOrigin = props.rel,
          rest = _objectWithoutPropertiesLoose(props, ["disabled", "href", "icon", "use", "loading", "_button", "_buttonOpened", "rel"]);

      var iconElement = null;

      if (icon) {
        iconElement = /*#__PURE__*/React.createElement("span", {
          className: styles.icon(_this.theme)
        }, loading ? /*#__PURE__*/React.createElement(Spinner, {
          caption: null,
          dimmed: true,
          type: "mini"
        }) : icon);
      }

      var arrow = null;

      if (_button) {
        arrow = /*#__PURE__*/React.createElement("span", {
          className: styles.arrow()
        });
      }

      var rel = relOrigin;

      if (typeof rel === 'undefined' && href) {
        rel = "noopener" + (isExternalLink(href) ? ' noreferrer' : '');
      }

      var focused = !disabled && _this.state.focusedByTab;
      var linkProps = {
        className: cx((_cx = {}, _cx[styles.root(_this.theme)] = true, _cx[styles.button(_this.theme)] = !!_button, _cx[styles.buttonOpened()] = !!_buttonOpened, _cx[styles.useDefault(_this.theme)] = use === 'default', _cx[styles.useSuccess(_this.theme)] = use === 'success', _cx[styles.useDanger(_this.theme)] = use === 'danger', _cx[styles.useGrayed(_this.theme)] = use === 'grayed', _cx[styles.useGrayedFocus(_this.theme)] = use === 'grayed' && focused, _cx[styles.focus(_this.theme)] = focused, _cx[styles.disabled(_this.theme)] = !!disabled || !!loading, _cx)),
        href: href,
        rel: rel,
        onClick: _this._handleClick,
        onFocus: _this._handleFocus,
        onBlur: _this._handleBlur,
        tabIndex: disabled || loading ? -1 : _this.props.tabIndex
      };
      return /*#__PURE__*/React.createElement("a", _extends({}, rest, linkProps), iconElement, _this.props.children, arrow);
    };

    _this._handleFocus = function (event) {
      if (!_this.props.disabled) {
        // focus event fires before keyDown eventlistener
        // so we should check tabPressed in async way
        requestAnimationFrame(function () {
          if (keyListener.isTabPressed) {
            _this.setState({
              focusedByTab: true
            });
          }
        });
      }
    };

    _this._handleBlur = function () {
      _this.setState({
        focusedByTab: false
      });
    };

    _this._handleClick = function (event) {
      var _this$props = _this.props,
          href = _this$props.href,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          loading = _this$props.loading;

      if (!href) {
        event.preventDefault();
      }

      if (onClick && !disabled && !loading) {
        onClick(event);
      }
    };

    return _this;
  }

  var _proto = Link.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.renderMain);
    });
  };

  return Link;
}(React.Component);
Link.__KONTUR_REACT_UI__ = 'Link';
Link.propTypes = {
  disabled: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  use: PropTypes.oneOf(['default', 'success', 'danger', 'grayed'])
};
Link.defaultProps = {
  href: '',
  use: 'default'
};